const e = "Einverstanden", n = "Feiern", o = "Abgeschlossen", s = "Nicht einverstanden", t = "Lustig", c = "Hallo", i = "Liebe", a = "Wow", l = {
  agree: e,
  celebrate: n,
  completed: o,
  disagree: s,
  funny: t,
  hi: c,
  love: i,
  wow: a
};
export {
  e as agree,
  n as celebrate,
  o as completed,
  l as default,
  s as disagree,
  t as funny,
  c as hi,
  i as love,
  a as wow
};
